<template>
    <v-card>
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="ml-n3 mr-2">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <h2 class="font-weight-regular">
                Set Processes
            </h2>
        </v-card-title>
        <v-divider class="mx-6" />
        <v-card-text>
            <v-form v-model="valid">
                <v-data-table
                    :headers="headers"
                    :items="filteredItems"
                    item-key="partNumberId"
                    class="elevation-0 mt-7"
                    :mobile-breakpoint="0"
                    :loading="loading"
                    disable-pagination
                    hide-default-footer
                    :style="{
                        'max-height': `${height}px`,
                        'overflow-y': 'auto',
                    }"
                >
                    <template v-slot:top>
                        <v-row
                            no-gutter
                            class="mt-0 mx-0 pt-4 pb-0 pb-4"
                            :style="{ 'background-color': '#eeeeee' }"
                        >
                            <v-col cols="6" class="d-flex align-center">
                                <h2 class="my-n3 d-flex align-center">
                                    ITEMS
                                </h2></v-col
                            >
                            <v-col cols="6" class="d-flex justify-end"
                                ><v-btn
                                    :loading="loading"
                                    color="primary"
                                    rounded
                                    class="mb-3 mr-3"
                                    @click="openProcessesDialog"
                                >
                                    SELECT PROCESSES
                                </v-btn>
                            </v-col>
                        </v-row>
                    </template>
                    <!--HEADERS-->
                    <template v-slot:[`header.selected`]="{ header }">
                        <div class="d-flex align-center justify-center">
                            <p class="ma-0 pr-2">{{ header.text }}</p>
                            <v-simple-checkbox
                                color="primary"
                                :value="allFilteredSelected"
                                :indeterminate="someFilteredSelected"
                                :disabled="filteredItems.length === 0"
                                class="d-flex align-center justify-center"
                                @click="toggleSelectAll"
                            ></v-simple-checkbox>
                        </div>
                    </template>
                    <template v-slot:[`header.partNumber`]="{ header }">
                        <v-text-field
                            :label="header.text"
                            v-model="partNumberToFilter"
                            dense
                            class="pt-2"
                        />
                    </template>
                    <!--ITEMS-->
                    <template v-slot:[`item.index`]="{ index }">
                        <p class="my-0">
                            {{ index + 1 }}
                        </p>
                    </template>
                    <template v-slot:[`item.code`]="{ item }">
                        <div class="d-flex justify-center">
                            <p class="my-0">{{ item.code }}</p>
                        </div>
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                        <div>
                            <p class="my-0">{{ item.description }}</p>
                        </div>
                    </template>
                    <template v-slot:[`item.productionInfo`]="{ item }">
                        <div
                            v-for="process in item.productionInfo"
                            :key="process.id"
                        >
                            <p class="my-0 text-left">
                                {{ process.name }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.newProcesses`]="{ item }">
                        <div
                            v-for="process in itemsProcesses"
                            :key="process.id"
                        >
                            <p class="my-0 text-left" v-if="item.selected">
                                {{ process.name }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.selected`]="{ item }">
                        <div class="d-flex justify-center">
                            <v-simple-checkbox
                                color="primary"
                                :value="!!item.selected"
                                @click="toggleItem(item)"
                            ></v-simple-checkbox>
                        </div>
                    </template>
                </v-data-table>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn
                :loading="loading"
                color="primary"
                rounded
                class="mb-3 mr-3"
                :disabled="
                    itemsProcesses.length === 0 || selectedItems.length === 0
                "
                @click="openConfirmDialog"
            >
                NEXT
            </v-btn>
        </v-card-actions>

        <!--ARRANGE PROCESSES-->
        <v-dialog
            :retain-focus="false"
            v-model="processesDialog"
            persistent
            max-width="400px"
        >
            <ArrangeProcesses
                v-if="processesDialog"
                :settingsProcesses="processes"
                :multipleItemSelect="true"
                :itemsProcesses="itemsProcesses"
                @closeDialog="closeProcessesDialog"
                @saveProcesses="saveProcesses"
            />
        </v-dialog>

        <v-dialog
            :retain-focus="false"
            v-model="confirmDialog"
            persistent
            max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <v-btn
                        small
                        icon
                        @click="closeConfirmDialog"
                        color="primary"
                        class="ml-n3 mr-2"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <h2 class="font-weight-regular">
                        Confirm Items Selected
                    </h2>
                </v-card-title>
                <v-divider class="mx-6" />
                <v-card-text>
                    <v-form v-model="valid">
                        <v-data-table
                            :headers="confirmHeaders"
                            :items="selectedItems"
                            item-key="partNumberId"
                            class="elevation-0 mt-7"
                            :mobile-breakpoint="0"
                            :loading="loading"
                            disable-pagination
                            hide-default-footer
                        >
                            <template v-slot:top>
                                <v-row
                                    no-gutter
                                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                                    :style="{ 'background-color': '#eeeeee' }"
                                >
                                    <v-col
                                        cols="12"
                                        class="d-flex align-center"
                                    >
                                        <h2 class="my-n3 d-flex align-center">
                                            ITEMS
                                        </h2></v-col
                                    >
                                </v-row>
                            </template>
                            <!--ITEMS-->
                            <template v-slot:[`item.itemsProcesses`]="{}">
                                <div
                                    v-for="process in itemsProcesses"
                                    :key="process.id"
                                >
                                    <p class="my-0 text-left">
                                        {{ process.name }}
                                    </p>
                                </div>
                            </template>
                            <template v-slot:[`item.qty`]="{ item }">
                                <div class="d-flex justify-center">
                                    <p class="my-0">{{ item.qtyToSend }}</p>
                                </div>
                            </template>
                        </v-data-table>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pt-0 pb-5">
                    <v-spacer></v-spacer>
                    <!-- Batch Progress Indicator -->
                    <div
                        v-if="batchProgress.isProcessing"
                        class="d-flex align-center mr-4"
                    >
                        <span class="text-caption">
                            Processing batch {{ batchProgress.current }} of
                            {{ batchProgress.total }}
                        </span>
                    </div>
                    <v-btn
                        color="primary"
                        rounded
                        :disabled="!valid"
                        :loading="loading"
                        @click="save"
                        class="mr-2"
                    >
                        SAVE
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'

export default {
    name: 'MultipleSend',
    components: {
        ArrangeProcesses: () =>
            import('@/components/WorkOrders/ArrangeProcesses.vue'),
    },
    props: {
        workOrder: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
        processes: { type: Object, required: true },
    },
    data: () => ({
        valid: false,
        loading: false,
        batchSize: 100, // Number of items to process per batch
        batchProgress: {
            current: 0,
            total: 0,
            isProcessing: false,
        },
        headers: [
            {
                text: 'ID',
                value: 'index',
                align: 'center',
                sortable: false,
                width: '50',
            },
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
            },
            {
                text: 'DESCRIPTION',
                value: 'description',
                align: 'left',
                sortable: false,
            },
            {
                text: 'OLD PROCESSES',
                value: 'productionInfo',
                align: 'left',
                sortable: false,
            },
            {
                text: 'NEW PROCESSES',
                value: 'newProcesses',
                align: 'left',
                sortable: false,
            },
            {
                text: 'SELECTED',
                value: 'selected',
                align: 'center',
                sortable: false,
            },
        ],
        confirmHeaders: [
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
            },
            {
                text: 'DESCRIPTION',
                value: 'description',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PROCESSES',
                value: 'itemsProcesses',
                align: 'left',
                sortable: false,
            },
        ],
        rules: {
            required: v => !!v || 'The value is required',
        },
        confirmDialog: false,
        processesDialog: false,
        itemsProcesses: [],
        height: 0,
        partNumberToFilter: undefined,
        localItems: [],
    }),
    computed: {
        filteredItems() {
            if (!this.partNumberToFilter) {
                return this.localItems
            }
            const filter = this.partNumberToFilter.toLowerCase()
            return this.localItems.filter(
                item =>
                    item.partNumber &&
                    item.partNumber.toLowerCase().includes(filter)
            )
        },
        selectedItems() {
            return this.localItems.filter(item => item.selected)
        },
        allFilteredSelected() {
            return (
                this.filteredItems.length > 0 &&
                this.filteredItems.every(item => item.selected)
            )
        },
        someFilteredSelected() {
            const selectedCount = this.filteredItems.filter(
                item => item.selected
            ).length
            return (
                selectedCount > 0 && selectedCount < this.filteredItems.length
            )
        },
    },
    mounted() {
        try {
            this.localItems = (this.workOrder.items || []).map(item => ({
                ...item,
                selected: false,
            }))
            this.onResize()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        async save() {
            try {
                this.loading = true
                const itemsToUpdate = this.selectedItems.map(i => ({
                    partNumberId: i.partNumberId,
                }))
                const processes = this.itemsProcesses.map(
                    process => process.id
                )
                const deliveryOptions = this.itemsProcesses.map(process => ({
                    id: process.id,
                    cancelSend: process.cancelSend || false,
                }))

                const totalBatches = Math.ceil(
                    itemsToUpdate.length / this.batchSize
                )

                this.batchProgress = {
                    current: 0,
                    total: totalBatches,
                    isProcessing: true,
                }

                for (let i = 0; i < itemsToUpdate.length; i += this.batchSize) {
                    const batch = itemsToUpdate.slice(i, i + this.batchSize)
                    const currentBatchNumber =
                        Math.floor(i / this.batchSize) + 1

                    this.batchProgress.current = currentBatchNumber

                    try {
                        await API.setBatchProcesses({
                            workOrderId: this.workOrder.id,
                            items: batch,
                            processes,
                            deliveryOptions,
                            settingProcessesId: this.processes.id,
                        })

                        if (i + this.batchSize < itemsToUpdate.length) {
                            await new Promise(resolve =>
                                setTimeout(resolve, 100)
                            )
                        }
                    } catch (error) {
                        this.batchProgress.isProcessing = false
                        this.setErrorItems({
                            source: this.$options.name,
                            message: error.message,
                        })
                        return
                    }
                }

                this.batchProgress.isProcessing = false
                this.$emit('closeDialog', {
                    partNumberIds: itemsToUpdate.map(
                        item => item.partNumberId
                    ),
                    processes,
                    deliveryOptions,
                })
            } catch (error) {
                this.batchProgress.isProcessing = false
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },

        openConfirmDialog() {
            this.confirmDialog = true
        },

        closeConfirmDialog() {
            this.confirmDialog = false
        },

        openProcessesDialog() {
            this.processesDialog = true
        },

        closeProcessesDialog() {
            this.processesDialog = false
        },

        saveProcesses(processes) {
            this.itemsProcesses = processes || []
            this.closeProcessesDialog()
        },

        close() {
            this.$emit('closeDialog')
        },

        onResize() {
            this.height = window.innerHeight - 260
        },
        toggleItem(item) {
            this.localItems = this.localItems.map(current => {
                if (current.partNumberId !== item.partNumberId) {
                    return current
                }
                return { ...current, selected: !current.selected }
            })
        },
        toggleSelectAll() {
            const visibleIds = new Set(
                this.filteredItems.map(item => item.partNumberId)
            )
            if (visibleIds.size === 0) {
                return
            }
            const nextSelected = !this.allFilteredSelected
            this.localItems = this.localItems.map(item => {
                if (!visibleIds.has(item.partNumberId)) {
                    return item
                }
                return { ...item, selected: nextSelected }
            })
        },
    },
}
</script>

<style></style>
